<template>
    <CProgress :style="'height: 3.5rem; margin-bottom: 15px; background-color: #c4c9d094'">
        <CProgressBar
            :value="segmentStart*100"
            style="visibility: hidden"
        />
        <CProgressBar
            :value="(segmentEnd - segmentStart)*100"
            :style="'border-radius: 2px;  background-color: ' + segmentColor"
        >

            <div style="width: 100%; height: 100%; position: relative">
                <span style="font-size: 24px; margin-top: 26px; display: block; color: #1d1b1b">{{ segmentName }}</span>
                <div :style="`position: absolute; border-radius: 2px 0 0 2px; top:0; height: 4rem; background-size: 1rem 1rem; background-image: linear-gradient(45deg,${hatchingColor} 25%,transparent 0,transparent 50%,${hatchingColor} 0,${hatchingColor} 75%,transparent 0,transparent); width: ${segmentStartFixDuration*100}%;`"></div>
                <div :style="`position: absolute; border-radius: 0 2px 2px 0; top:0; right: 0px; height: 4rem; background-size: 1rem 1rem; background-image: linear-gradient(45deg,${hatchingColor} 25%,transparent 0,transparent 50%,${hatchingColor} 0,${hatchingColor} 75%,transparent 0,transparent); width: ${segmentEndFixDuration*100}%;`"></div>
            </div>

        </CProgressBar>
        <CProgressBar
            :value="(1-segmentEnd)*100"
            style="visibility: hidden"
        />
    </CProgress>
</template>

<script>
    export default {
        props: {
            segmentName: {},
            segmentColor: {},
            segmentStart: {},
            segmentEnd: {},
            segmentStartFixDuration: {},
            segmentEndFixDuration: {},
            hatchingColor: {}
        }
    }
</script>